import React, { useState, useEffect } from 'react';

import './style.scss';

let timer = null;
const Timer = ({ timerStart, totalTime, endTest }) => {
  const [timeRemaining, setTimeRemaining] = useState(totalTime);
  let done = null;

  const startTimer = () => {
    timer = setInterval(() => {
      setTimeRemaining((prevState) => prevState - 1000);
    }, 1000);
  };

  useEffect(() => {
    if (timeRemaining === 0) {
      clearInterval(timer);
      endTest();
    }
  }, [timeRemaining, endTest]);

  useEffect(() => {
    startTimer();
    return () => {
      clearInterval(timer);
    };
  }, []);

  const getTime = () => {
    let sec = timeRemaining / 1000;
    let hours = Math.floor(sec / (60 * 60));
    let minutes = Math.floor((sec - hours * 60 * 60) / 60);
    let seconds = Math.floor(sec - hours * 60 * 60 - minutes * 60);

    if (minutes <= 4 && hours === 0 && done === null) {
      done = true;
    }

    // minutes += hours * 60

    if (hours > 0) {
      if (hours === 1 && minutes === 0) {
        minutes = 59;
        return ('0' + minutes).slice(-2) + ' : ' + ('0' + seconds).slice(-2);
      }
      return ('0' + hours).slice(-2) + ' : ' + ('0' + minutes).slice(-2);
    } else {
      // return ("0" + hours).slice(-2) + " : " + ("0" + minutes).slice(-2) + " : " + ("0" + seconds).slice(-2)
      return ('0' + minutes).slice(-2) + ' : ' + ('0' + seconds).slice(-2);
    }
  };
  return <div className='timer'>{getTime()}</div>;
};

export default Timer;
